<div>
    <app-tool-bar 
        [title]="'Manage ' + (activeTab === 'lead' ? 'Lead' : activeTab === 'registration' ? 'Registration' : activeTab === 'application' ? 'Application' : activeTab === 'enrollment' ? 'Enrollment' : 'Admission') + ' Fields'" 
        [iconName]="'pi-calendar'" 
        [isAdd]="true"
        (handleAdd)="handleAddLeadField()"
    ></app-tool-bar>
</div>

<!-- Tabs Section - Same as Lead Component -->
<div class="p-4 overflow-auto h-[85vh]">
  <div class="tab-container">
    <div *ngFor="let tab of tabs" class="outer-tab flex items-center" [ngClass]="{ 'active': tab.isActive, 'inactive': !tab.isActive }" (click)="setActiveTab(tab.value)">
      <div class="tab">
        {{ tab.label }}
      </div>
    </div>
  </div>

  <div class="mt-4">
    <!-- <p-progressbar mode="indeterminate" [style]="{ height: '3px' }"
    *ngIf="!initialLoad && loading"></p-progressbar> -->
    <p-table [value]="dataSource" [paginator]="true" [rows]="rows" 
    [rowsPerPageOptions]="[5, 10, 20, 50]"
    [loading]="initialLoad || loading"
    [showCurrentPageReport]="true"
     currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    >
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.sortable ? col.field : ''">
                    {{ col.header }}
                    <ng-container *ngIf="col.field === 'sequence'">
                        <i class="pi pi-info-circle text-gray-400 ml-1 cursor-pointer" pTooltip="Field order: Lower sequence numbers appear first in the form." tooltipPosition="top"></i>
                    </ng-container>
                    <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
            <tr [ngClass]="{'disabled-row': rowData.is_fixed === true}">
                <td *ngFor="let col of columns">
                    <ng-container [ngSwitch]="col.type">
                        <!-- Handle Nested Object (Lead Owner) -->
                        <ng-container *ngSwitchCase="'nested'">
                            {{ (rowData.user?.prefix ?? 'N/A') +
                            (rowData.user?.fname ? ' ' + rowData.user.fname : '') +
                            (rowData.user?.lname ? ' ' + rowData.user.lname : '') }}
                        </ng-container>
    
                        <!-- Handle Boolean -->
                        <ng-container *ngSwitchCase="'number'">
                            {{
                               rowData[col.field]  || 0
                            }}
                        </ng-container>

                        <ng-container *ngSwitchCase="'placeholder'">
                            {{
                               rowData[col.field]  || 'N/A'
                            }}
                        </ng-container>

                        <!-- Handle Fixed Column Badge -->
                        <ng-container *ngSwitchCase="'fixed'">
                            <span *ngIf="rowData.is_fixed === true" class="px-2 py-1 bg-orange-100 text-orange-800 text-xs font-semibold rounded">
                                Fixed
                            </span>
                            <span *ngIf="rowData.is_fixed !== true" class="text-gray-400">
                                <!-- dynamic -->
                                 Dynamic
                            </span>
                        </ng-container>
    
                        <!-- Handle Actions -->
                        <ng-container *ngSwitchCase="'actions'">
                            <div *ngIf="!rowData.is_fixed">
                                <p-menu [tabindex]="undefined" #menu [model]="getMenuItems(rowData)" [popup]="true" appendTo="body"></p-menu>
                                <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button"></i>
                            </div>
                            <span *ngIf="rowData.is_fixed" class="text-gray-400 text-sm">No Actions</span>
                        </ng-container>
    
                        <!-- Default Case (Normal Field) -->
                        <ng-container *ngSwitchDefault>
                            {{ rowData[col.field]  }}
                        </ng-container>
                    </ng-container>
                </td>
            </tr>
        </ng-template>
    
        <ng-template pTemplate="loading">
            <tr>
                <td colspan="3" class="text-center">
                    <p-progressSpinner></p-progressSpinner>
                </td>
            </tr>
        </ng-template>

        <!-- when data length is 0 -->

        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="columns.length" class="no-data">
                    <p>No records found</p>
                </td>
            </tr>
        </ng-template>

    </p-table>
</div>

<p-dialog [modal]="true" [(visible)]="isAddLeadField"  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" closable="false"
[style]="{ width: '50vw' }" [draggable]="false" [resizable]="false" [header]="'Add Field Form'">
    <ng-container *ngIf="isAddLeadField">
    <app-add-lead-field
    (closeDialog)="handleCloseDialog()"
    [dataSource]="dataSource"
    [moduleType]="activeTab"
    (reload)="getLeadsFields()"
    ></app-add-lead-field>
</ng-container>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isEditField"  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" closable="false"
[style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isEditField">
    <app-add-lead-field
    [formAction]="'Edit'"
    (closeDialog)="isEditField = false"
    [editLeadFieldData]="editLeadFieldData"
    [moduleType]="activeTab"
    (reload)="getLeadsFields()"
    ></app-add-lead-field>
</ng-container>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isDeleteUser"  [breakpoints]="{ '1199px': '40vw', '575px': '90vw' }" closable="false"
[style]="{ width: '30vw' }" [draggable]="false" [resizable]="false">
    <app-delete-lead-field
    [editLeadFieldData]="editLeadFieldData"
    (reload)="getLeadsFields()"
    (closeDialog)="isDeleteUser = false"></app-delete-lead-field>
</p-dialog>